import { ISchool } from './../../../../_models/account/ISchool';
import { IKeyValuePair } from './../../../../_models/common/common';
import { CommonService } from './../../../../shared/services/common.service';
import { SchoolService } from './../../../../shared/services/school.service';
import { ToastrService } from 'ngx-toastr';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-school-form',
  templateUrl: './school-form.component.html'
})
export class SchoolFormComponent implements OnInit {

  loading: boolean;
  title: string = 'Add School/Place';
  school: ISchool;
  schoolForm: FormGroup;
  id;

  regions: IKeyValuePair[];
  states: IKeyValuePair[];
  districts: IKeyValuePair[];
  schoolTypes: IKeyValuePair[];
  schoolLevels: IKeyValuePair[];

  constructor(private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private toastrService: ToastrService,
    private service: SchoolService,
    private commonService: CommonService,) {
    this.id = this.route.snapshot.paramMap.get('id');
  }

  ngOnInit() {
    this.createSchoolForm();
    this.bindDropDown();
    if (this.id) this.service.get(this.id).subscribe((response: ISchool) => {
      if (response) {
        this.school = response;
        this.title = 'Edit School/Place';
        this.setValueSchoolForm();
      }
    });
  }


  bindDropDown() {
    this.commonService.getRegions().subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.regions = response;
      }
    });
    this.commonService.getSchoolTypes().subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.schoolTypes = response;
      }
    });
    this.commonService.getSchoolLevels().subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.schoolLevels = response;
      }
    });
  }

  getStates(regionId: string) {
    this.commonService.getStates(regionId).subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.states = response;
      }
    });
  }

  getDistricts(stateId: number) {
    this.commonService.getDistricts(stateId).subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.districts = response;
      }
    });
  }

  createSchoolForm() {
    this.schoolForm = this.fb.group({
      userId: [''],
      email: ['', [Validators.required, Validators.email]],
      name: ['', [Validators.required]],
      regionId: ['', Validators.required],
      stateId: ['', Validators.required],
      districtId: ['', Validators.required],
      schoolTypeId: ['', Validators.required],
      schoolLevelId: ['', Validators.required],
      address: [''],
      phone: [''],
      fax: [''],
      isActive: [true, Validators.required],
      isFemaleSchool: [false, Validators.required]
    });
  }

  setValueSchoolForm() {

    if (this.school.regionId) {
      this.getStates(this.school.regionId);
    }

    if (this.school.stateId) {
      this.getDistricts(this.school.stateId);
    }

    this.schoolForm.patchValue({
      userId: this.school.userId,
      email: this.school.email,
      name: this.school.name,
      regionId: this.school.regionId,
      stateId: this.school.stateId,
      districtId: this.school.districtId,
      schoolTypeId: this.school.schoolTypeId,
      schoolLevelId: this.school.schoolLevelId,
      address: this.school.address,
      phone: this.school.phone,
      fax: this.school.fax,
      isActive: this.school.isActive,
      isFemaleSchool: this.school.isFemaleSchool,
    });
  }

  save() {
    if (this.schoolForm.valid) {
      this.loading = true;
      this.school = Object.assign({}, this.schoolForm.value);
      if (this.id) {
        this.service.update(this.id, this.school).subscribe(() => {
          this.toastrService.success('school/place updated successful');
          this.router.navigate(['/admin/regions/states/districts/schools']);
        },
          (error) => console.log('HTTP Error', error),
          () => this.loading = false);
      }
      else {
        this.service.create(this.school).subscribe(() => {
          this.toastrService.success('school/place created successful');
          this.router.navigate(['/admin/regions/states/districts/schools']);
        },
          (error) => console.log('HTTP Error', error),
          () => this.loading = false);
      }
    }
  }

  delete() {
    if (!confirm('Are you sure you want to delete this school/place?')) return;

    this.service.delete(this.id).subscribe(() => {
      this.toastrService.success('school/place deleted successful');
      this.router.navigate(['/admin/regions/states/districts/schools']);
    });
  }

}
